import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { useWasm, WasmContextProvider, WasmStatus } from "@sequentech/ui-core";
import { Loader } from "@sequentech/ui-essentials";
export var WasmGate = function (_a) {
    var children = _a.children;
    var status = useWasm().status;
    return WasmStatus.READY === status ? _jsx(_Fragment, { children: children }) : _jsx(Loader, {});
};
export var WasmWrapper = function (_a) {
    var children = _a.children;
    return (_jsx(WasmContextProvider, { children: _jsx(WasmGate, { children: children }) }));
};
